export const sendFormspree = async (payload) => {
  const response = await fetch(process.env.REACT_APP_FORMSPREE_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error('Formspree submit failed');
  }

  return response.json();
};